import styled from 'styled-components'

import { Text } from '@reveni-io/reveni-ui'

export const Container = styled.section`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp16};
`

export const Toggle = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp4};
`

export const ToggleHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${props => props.theme.spacing.sp8};
`

export const Helper = styled(Text)`
  color: ${props => props.theme.colors.text.muted};
`

export const DateRow = styled.div`
  display: flex;
  gap: ${props => props.theme.spacing.sp16};

  > * {
    flex: 1;
    min-width: 0;
  }
`

export const DateLimit = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp4};
`

export const ErrorText = styled(Text)`
  color: ${props => props.theme.colors.danger.default};
`
